export default __webpack_public_path__ + "static/media/preview-special-media.b3331ee3.jpg";